

























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
// @ts-ignore
import store from "../../store";
import { Tasks } from "../../../types/tasks";
import axiosInstance from "../../axios";
import {ContentPack, CurrentGame} from "../../../types";
import EventApi from "../../api/EventsApi";

@Component({
    components: {},
})

export default class PlayAgainModal extends Vue {
    private email: string = '';
    private formErrorIsVisible: boolean = false;
    private formErrorText: string = '';
    private formSuccess: boolean = false;

    private get subscribeUrl(): null | string
    {
        return store.getters.getSubscribeUrl;
    }

    /**
     * Список игр
     * @private
     */
    private get activitiesList(): Array<Tasks.TActivity> | null
    {
        return store.getters.getActivitiesList;
    }

    /**
     * Избранные игры
     */
    private get featuredGames(): Array<Tasks.TActivity> | null
    {
        if (!this.activitiesList) {
            return null;
        }

        return this.activitiesList.reduce((games: Array<Tasks.TActivity>, game: Tasks.TActivity) => {
            Object.values(game.contentPacks).forEach((pack: Tasks.TContentPack) => {
                if (pack.is_homepage_visible) {
                    games.push(game);
                }
            });
            return games;
        }, []);
    }

    /**
     * Открыть каталог с выбранным паком
     * @param game
     * @param pack
     * @private
     */
    private openFeaturedGame(game: Tasks.TActivity, pack: Tasks.TContentPack): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        EventApi.triggerEvent(EventApi.OPEN_CATALOG, {game, pack});
        this.$emit('close');
    }

    /**
     * Подписаться
     * @private
     */
    private subscribe(): void
    {
        if (!this.subscribeUrl) {
            console.log('There is no subscribe endpoint');
            return;
        }

        axiosInstance.post(this.subscribeUrl, { email: this.email })
        .then( response => {
            console.log(response);
            if (typeof response.data.error === 'undefined') {
                this.formSuccess = true;
                setTimeout(() => {
                    this.formSuccess = false;
                }, 3000);
            } else {
                this.formErrorIsVisible = true;
                this.formErrorText = typeof response.data.error.message.email[0] !== 'undefined'
                    ? response.data.error.message.email[0]
                    : 'Try again!'
            }
        }).catch(error => {
            console.log(error);
        });
    }

    /**
     * Свернуть модалку
     * @private
     */
    private coverModal(): void
    {
        this.$emit('cover');
    }
}
